<template lang="pug">
	.station-streaming-encoders-detail
		h2 {{$tCaption('Streaming encoder')}}
		.flex-row.space-large
			.flex-col.space-large.flex-1
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Server type')}}
					DxSelectBox(:items="serverTypes", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="streamingEncoder.ServerType")
				.flex-col.field(v-if="isServerShoutcastV2")
					.font-small.grey.upper {{$tCaption('Stream ID')}}
					DxNumberBox(:value.sync="streamingEncoder.StreamId")
						dx-validator
							dx-required-rule
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Bitrate')}}
					DxNumberBox(:value.sync="streamingEncoder.Bitrate")
						dx-validator
							dx-required-rule
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Sample rate')}}
					DxNumberBox(:value.sync="streamingEncoder.SampleRate")
						dx-validator
							dx-required-rule
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Audio codec')}}
					DxSelectBox(:items="audioCodecTypes", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="streamingEncoder.AudioCodec")
				template(v-if="streamingEncoder.AudioCodec === 3")
					DxCheckBox(:value="!!streamingEncoder.Afterburner", :text="$tCaption('Afterburner')", @value-changed="v => streamingEncoder.Afterburner = v.value", :activeStateEnabled="false", :focusStateEnabled="false")
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Username')}}
					DxTextBox(:value.sync="streamingEncoder.UserName" :read-only="isServerShoutcastV1")
						dx-validator(ref="userNameValidator")
							dx-required-rule
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Password')}}
					DxTextBox(:value.sync="streamingEncoder.Password", mode="password", :input-attr="{ autocomplete: 'new-password', id: 'streaming-encoder-password' }")
			.flex-col.space-large.flex-1
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Host')}}
					DxTextBox(:value.sync="streamingEncoder.Host")
						dx-validator
							dx-required-rule
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Port')}}
					DxNumberBox(:value.sync="streamingEncoder.Port")
						dx-validator
							dx-required-rule
							dx-custom-rule(:validation-callback="() => streamingEncoder.Port !== 0", :message="$tCaption('Port can not be 0')")
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Reconnect timeout')}}
					DxNumberBox(:value.sync="streamingEncoder.ReconnectTimeOut")
						dx-validator
							dx-required-rule
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Mounting point')}}
					DxTextBox(:value.sync="streamingEncoder.MountPoint")
						dx-validator
							dx-required-rule(:message="$tCaption('For shout and icecast, mounting point can not be empty')")
				.flex-col.field
					.flex-row.space
						dxCheckBox(:value.sync="streamingEncoder.IsPublic", :width="35")
						.font-small.grey.upper {{$tCaption('Is public')}}
				.flex-col.field
					.flex-row.space
						dxCheckBox(:value.sync="streamingEncoder.Enabled", :width="35")
						.font-small.grey.upper {{$tCaption('Enabled')}}
		h2 {{$tCaption('Streaming')}}
		.flex-row.space-large
			.flex-col.space-large.flex-1
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Streaming name')}}
					DxTextBox(:value.sync="streamingEncoder.StreamingName")
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Streaming Url')}}
					DxTextBox(:value.sync="streamingEncoder.StreamingUrl")
						dx-validator
							dx-required-rule
			.flex-col.space-large.flex-1
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Streaming genre')}}
					DxTextBox(:value.sync="streamingEncoder.StreamingGenre")
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Streaming description')}}
					DxTextBox(:value.sync="streamingEncoder.StreamingDescription")
		h2 {{$tCaption('Flip')}}
		.flex-row.space-large
			.flex-col.space-large.flex-1
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Flip bit break mode')}}
					DxSelectBox(:items="flipBitBreakModes", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="streamingEncoder.FlipBitBreakMode")
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Flip bit break type')}}
					DxSelectBox(:items="flipBitBreakTypes", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="streamingEncoder.FlipBitBreakType")
			.flex-col.space-large.flex-1
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Flip bit spot mode')}}
					DxSelectBox(:items="flipBitSpotModes", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="streamingEncoder.FlipBitSpotMode")
				.flex-col.field
					.font-small.grey.upper {{$tCaption('Flip bit spot type')}}
					DxSelectBox(:items="flipBitSpotTypes", value-expr="id", display-expr="name", :search-enabled="false", :value.sync="streamingEncoder.FlipBitSpotType")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import Loader from 'app-core/Loader.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import CartoMap from 'view/carto/CartoMapComponent.vue';
	import DxTextArea from 'devextreme-vue/text-area';
	import { DxCheckBox } from 'devextreme-vue/check-box';
	import { DxNumberBox } from 'devextreme-vue/number-box';
	import { DxSlider } from 'devextreme-vue/slider';
	import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';

	export default {
		translationCategory: 'station.StreamingEncodersDetail',
		name: 'station-streaming-encoders-detail',
		components: {
			DxButton, DxTextBox, Loader, DxDateBox, Dropdown, CartoMap, DxTextArea, DxCheckBox, DxSelectBox, DxNumberBox, DxSlider, DxValidator, DxRequiredRule, DxCustomRule
		},
		props: [
			'streamingEncoder',
			'serverTypes',
			'audioCodecTypes',
			'flipBitBreakModes',
			'flipBitBreakTypes',
			'flipBitSpotModes',
			'flipBitSpotTypes'
		],
		data() {
			return {
				innerStreaminEncoder: _.clone(this.streamingEncoder)
			};
		},
		watch: {
			isServerShoutcastV1: {
				handler: function (val) {
					this.streamingEncoder.UserName = val ? 'source' : this.streamingEncoder.UserName;

					const userNameValidator = this.$refs.userNameValidator
					if (userNameValidator) {
						userNameValidator.instance.reset();
					}
				},
				immediate: true,
			}
		},
		computed: {
      serverType() {
				const {name: serverType} = this.serverTypes.find(({id}) => this.streamingEncoder.ServerType === id);
				return serverType;
			},
			mountPointRequired() {
				return !((this.serverType.toLowerCase().includes('shoutcast') || this.serverType.toLowerCase().includes('icecast')));
			},
			isServerShoutcastV1() {
				return this.serverType === 'Shoutcastv1'
			},
			isServerShoutcastV2() {
				return this.serverType === 'Shoutcastv2'
			},
		},
		mounted() {
			if (__DEBUG__)	
				window.streamingEncoderDetail = this;
		},
	};
</script>
 